const date = new Date();
const year = date.getFullYear();

export const LAST_YEAR = (year - 1).toString();
export const CURRENT_YEAR = year.toString();
export const NEXT_YEAR = (year + 1).toString();

export const MONTHS_OF_THE_YEAR = [
  {
    text: 'Январь',
    value: '1',
  },
  {
    text: 'Февраль',
    value: '2',
  },
  {
    text: 'Март',
    value: '3',
  },
  {
    text: 'Апрель',
    value: '4',
  },
  {
    text: 'Май',
    value: '5',
  },
  {
    text: 'Июнь',
    value: '6',
  },
  {
    text: 'Июль',
    value: '7',
  },
  {
    text: 'Август',
    value: '8',
  },
  {
    text: 'Сентябрь',
    value: '9',
  },
  {
    text: 'Октябрь',
    value: '10',
  },
  {
    text: 'Ноябрь',
    value: '11',
  },
  {
    text: 'Декабрь',
    value: '12',
  },
];

export const YEARS = [
  {
    text: LAST_YEAR,
    value: LAST_YEAR,
  },
  {
    text: CURRENT_YEAR,
    value: CURRENT_YEAR,
  },
  {
    text: NEXT_YEAR,
    value: NEXT_YEAR,
  },
];



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterselect/consts.ts